import PageTitle from '@components/Components/Reusables/PageTitle';
import P from '@components/Components/Reusables/Typography/P';
import Container from '@mui/material/Container';

const listItems = [
  'Selecting delivery & collection times to suit you',
  'Get the best product thanks to the variety available',
  'Next day deliveries for when you need items quickly',
  'No complex delivery arrangements - we deliver across the UK',
  'You can update your office/venue furniture in seconds',
  'Long-term hire gives you the chance to save more money'
]

const Heading = ({children}) => <PageTitle color="primary" as="h2">{children}</PageTitle>

export default function FurnitureRental() {

    return (
        <div>
			<PageTitle className="m-0 ml-2" as="h1">Furniture Rental - Why Should I Choose This Option?</PageTitle>
			<Container className="mb-5">
				<P className>Furniture rental allows you to obtain all the items you need for any event at a fraction of the cost of purchasing them.</P>

				<Heading>How Renting Furniture Saves Money</Heading>
				<P>Choosing to rent chairs, tables or any other type of furniture for your function has lots of benefits, including:</P>
				<ul className="list-disc pl-4">
					{listItems.map(item => (
						<li key={item}>{item}</li>
					))}
				</ul>

				<Heading>Renting V's Buying</Heading>
				<P>Purchasing furniture can feel like an investment - especially when you're using capital to fund what you buy. Furniture rental is a much more flexible arrangement and it often results in little capital expenditure, as compared with buying the same products outright. This money-saving aspect is a really popular reason why lots of companies chose to rent over buying. Payments are smaller, and long-term hire allows you to include rental fees into your business operating costs.</P>

				<Heading>Our Furniture Rental Services are Fully Flexible</Heading>
				<P>Buying generally means you invest in an item and use it until you want to replace it, where you might then purchase another product, and arrange it's delivery and installation. With rental, you select the products you require for your event, and you can change your mind each time you order.</P>
				<P>
					New stock is constantly being added to our website, meaning our clients can select the latest products available. Many individuals stick with items they are familiar with, but like everything, change is as good as a holiday. If you've always chosen stacking chairs for example why not add some colour to your event space with our Esme options.
				</P>

				<Heading>Delivery, Set-up, Collection - We have it covered!</Heading>
				<P>Buying goods usually involves arranging delivery initially and then collection or disposal, if you're looking for replacements in the future. When you hire furniture from us we transport our products to any London & UK venue, then collect them, at any time of the day/night. You're also free to opt for our full set-up service, which means we install and dismantle your entire order for you.</P>
			</Container>
        </div>
    );
}
